import { eventbus } from '@/core/eventbus'
import type { Handler } from 'mitt'
import { onBeforeUnmount, onMounted } from 'vue'

export function useDialogMessage(_sender: string) {
  const subscribes: [string, Handler][] = []

  function OpenDialogCommand(id: string) {
    eventbus.emit('Map.Dialog.OpenDialogCommand', { id, _sender })
  }

  function CloseDialogCommand(id: string) {
    eventbus.emit('Map.Dialog.CloseDialogCommand', { id, _sender })
  }

  function onOpenDialogCommand(handler: Handler<unknown>) {
    subscribes.push(['Map.Dialog.OpenDialogCommand', handler])
  }

  function onCloseDialogCommand(handler: Handler<unknown>) {
    subscribes.push(['Map.Dialog.CloseDialogCommand', handler])
  }

  onMounted(() => {
    subscribes.forEach(([type, handler]) => eventbus.on(type, handler))
  })

  onBeforeUnmount(() => {
    subscribes.forEach(([type, handler]) => eventbus.off(type, handler))
  })
  return {
    OpenDialogCommand,
    CloseDialogCommand,
    onOpenDialogCommand,
    onCloseDialogCommand,
  }
}
